export default "../fonts/akzidgrtskpromedcnd-webfont.fad796a3195b3db9358cc30d305985cb.ttf";